import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_ENDPOINT } from "../../../../services/api/resources";
import classes from './charts.module.css';
import TablePagination from "./Pagination";
import HeaderTitle from "../../../../components/common/HeaderTitle/HeaderTitle";

const PendingESignatureTable = () => {
    const [vendorInvoiceData, setVendorInvoiceData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [statusFilter, setStatusFilter] = useState("All");
    const [currentPage, setCurrentPage] = useState(1);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

    const [loading, setLoading] = useState(true);




    const rowsPerPage = 10;

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const res = await axios.get(API_ENDPOINT.get_all_invoices);
                setVendorInvoiceData(res.data?.invoices || []);
            } catch (error) {
                console.error("Error fetching invoice data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);


    const handleSort = (key) => {
        setSortConfig((prev) => {
            const direction = prev.key === key && prev.direction === "asc" ? "desc" : "asc";
            return { key, direction };
        });
    };

    const filteredData = vendorInvoiceData.filter((invoice) => {
        const nameMatch = invoice.vendor_name
            .toLowerCase()
            .includes(searchTerm.toLowerCase());
        const invoiceMatch = invoice.vendor_code
            .toLowerCase()
            .includes(searchTerm.toLowerCase());
        const statusMatch =
            statusFilter === "All" || invoice.esign_status === statusFilter;
        return (nameMatch || invoiceMatch) && statusMatch;
    });

    const sortedData = [...filteredData].sort((a, b) => {
        if (!sortConfig.key) return 0;

        const valA = a[sortConfig.key];
        const valB = b[sortConfig.key];

        if (typeof valA === "string") {
            return sortConfig.direction === "asc"
                ? valA.localeCompare(valB)
                : valB.localeCompare(valA);
        } else if (typeof valA === "number") {
            return sortConfig.direction === "asc" ? valA - valB : valB - valA;
        } else if (Date.parse(valA)) {
            return sortConfig.direction === "asc"
                ? new Date(valA) - new Date(valB)
                : new Date(valB) - new Date(valA);
        }
        return 0;
    });

    const indexOfLastItem = currentPage * rowsPerPage;
    const indexOfFirstItem = indexOfLastItem - rowsPerPage;
    const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredData.length / rowsPerPage);

    return (
        <div className={classes.tablecontainer} style={{ marginTop: '1rem' }}>
            <HeaderTitle titleText={"Pending E-Signature by Merchant"} />

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div className={classes.filtercontainer}>
                    <select
                        value={statusFilter}
                        onChange={(e) => {
                            setStatusFilter(e.target.value);
                            setCurrentPage(1);
                        }}
                        className="filter-select"
                    >
                        <option value="All">All</option>
                        <option value="Signed">Signed</option>
                        <option value="Not Signed">Not Signed</option>
                    </select>
                </div>

                <div className={classes.searchbar}>
                    <input
                        type="text"
                        placeholder="Search by name or invoice No..."
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setCurrentPage(1);
                        }}
                        className="search-input"
                    />
                </div>
            </div>

            <table className={classes.statustable}>
                <thead>
                    <tr>
                        <th onClick={() => handleSort("vendor_code")}>
                            Invoice No. {sortConfig.key === "vendor_code" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                        </th>
                        <th onClick={() => handleSort("vendor_name")}>
                            Merchant Name {sortConfig.key === "vendor_name" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                        </th>
                        <th onClick={() => handleSort("amount")}>
                            Amount {sortConfig.key === "amount" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                        </th>
                        <th onClick={() => handleSort("created_on")}>
                            Uploaded On {sortConfig.key === "created_on" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                        </th>
                        <th onClick={() => handleSort("esign_status")}>
                            Status {sortConfig.key === "esign_status" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="7" className={classes.loadingRow}>Loading data...</td>
                        </tr>
                    ) : currentItems.length === 0 ? (
                        <tr>
                            <td colSpan="5" className="no-data">No data found</td>
                        </tr>
                    ) : (
                        currentItems.map((invoice) => (
                            <tr key={invoice.id}>
                                <td>{invoice.vendor_code}</td>
                                <td>{invoice.vendor_name}</td>
                                <td>₹{parseInt(invoice.amount).toLocaleString()}</td>
                                <td>{new Date(invoice.created_on).toLocaleDateString()}</td>
                                <td>{invoice.esign_status}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>

            {filteredData.length > rowsPerPage && (
                <TablePagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={setCurrentPage}
                    totalItems={filteredData.length}
                />
            )}
        </div>
    );
};

export default PendingESignatureTable;
